import { render, staticRenderFns } from "./runForIt.vue?vue&type=template&id=0cb880e4&"
import script from "./runForIt.vue?vue&type=script&lang=js&"
export * from "./runForIt.vue?vue&type=script&lang=js&"
import style0 from "./runForIt.vue?vue&type=style&index=0&id=0cb880e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports